import axios, { AxiosError, AxiosResponse } from "axios";
import { injectable } from "inversify";
import "reflect-metadata";
import { Configuration } from "../api";
import { BaseAPI } from "../api/base";
import { RoutingPaths } from "../pages/routing/routingContainer";
import { AlertObj, setAlert } from "../redux/alertSlice";
import { store } from "../redux/store";
import {createBrowserHistory} from 'history';
import { userManager } from "../App";

@injectable()
export default class ApiService {
    constructor() {
        axios.interceptors.response.use(
            (response: AxiosResponse) => {
                // Any status code that lie within the range of 2xx cause this function to trigger
                // Do something with response data
                return response;
            },
            function (error: AxiosError) {
                if (error.response?.status === 401) {
                    store.dispatch(setAlert(
                        {
                            message: "Twoja sesja wygasła",
                            description: "Przekierowanie do ekranu logowania.",
                            type: "warning"
                        } as AlertObj
                    ));
                    userManager?.removeUser().then(() => 
                        userManager?.signinRedirect({ state: { targetPath: window.location.pathname } })
                    );
                } else if (error.response?.status === 403) {
                    store.dispatch(setAlert(
                        {
                            message: "Wygląda na to że nie masz dostępu do danego zasobu.",
                            description: "Spróbuj zalogować się ponownie, a jeżeli to nie pomoże, skontaktuj się z administratorem.",
                            type: "warning"
                        } as AlertObj
                    ));
                } else if (error.response?.status !== 400) {
                    store.dispatch(setAlert(
                        {
                            message: "Wystąpił błąd. Jeżeli będzie się to powtarzać, skontaktuj się z administratorem.",
                            description: error.message,
                            type: "error"
                        } as AlertObj
                    ));
                }
                return Promise.reject(error);
            }
        );
        axios.defaults.withCredentials = true;
    }

    public getApi<T extends BaseAPI>(c: new (configuration?: Configuration, basePath?: string) => T): T {
        const apiUrl = process.env.REACT_APP_URL;
        const session = sessionStorage.getItem(`oidc.user:${apiUrl}:BeeftekaBackend.Web`);
        const accessToken = session ? JSON.parse(session)["access_token"] : null;

        return new c(new Configuration({ accessToken }), apiUrl);
    }
}
